import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-violet-gradient text-white pt-6 pb-2 px-3 md:pt-12 md:pb-4 overflow-hidden" data-id="element-168">
      <div className="max-w-xl mx-auto text-center" data-id="element-169">
        <div className="animate-fadeInUp" data-id="element-170">
          {/* Small badge */}
          <div className="inline-block bg-brand-yellow/10 text-brand-yellow px-4 py-1.5 rounded-full text-xs font-bold mb-4 border border-brand-yellow/20 tracking-wide uppercase" data-id="element-171">
            🧠 SISTEMA COMPLETO PARA GESTIONAR TUS EMOCIONES CON CLARIDAD
          </div>

          {/* Main headline */}
          <h1 className="text-[2rem] md:text-5xl lg:text-6xl font-extrabold leading-[1.1] mb-3 px-0 text-gray-50" data-id="element-172">
            👉 Empezá hoy a entender lo que te pasa y{' '}
            <span className="bg-gradient-to-r from-amber-300 to-brand-yellow bg-clip-text text-transparent" data-id="element-173">
              mejorá tu año...
            </span>
          </h1>

          {/* Product image with radial glow - further reduced size */}
          <div className="relative mb-6 max-w-[280px] md:max-w-[360px] mx-auto radial-glow" data-id="element-174">
            <img src="https://cdn.magicpatterns.com/uploads/6mzhzpPNjw8QwRTv3jNdrB/MOCKUP_1_600x.png" alt="MegaPack AutoCoaching Emocional" className="w-full h-auto drop-shadow-[0_20px_60px_rgba(0,0,0,0.6)] hover:scale-[1.02] transition-transform duration-500 relative z-10" data-id="element-175" />
          </div>

          {/* Yellow highlight text */}
          <p className="text-brand-yellow text-base md:text-lg font-medium italic mb-3 max-w-sm mx-auto leading-snug" data-id="element-176">
            Listo para aplicar. Sin sobrepensar. Sin explotar emocionalmente.
            Sin depender de otros para ordenar lo que sentís…
          </p>

          {/* Full-width CTA */}
          <CTAButton text="👉 QUIERO EMPEZAR A GESTIONAR MIS EMOCIONES HOY" className="w-auto mx-auto mb-5 py-3 px-6 text-sm md:text-base font-black rounded-xl" data-id="element-177" />

          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] md:text-xs text-gray-500" data-id="element-178">
            <div className="flex items-center gap-1" data-id="element-179">
              <ShieldCheck size={14} className="text-brand-yellow" data-id="element-180" />
              <span data-id="element-181">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-182">
              <Lock size={14} className="text-brand-yellow" data-id="element-183" />
              <span data-id="element-184">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-185">
              <CreditCard size={14} className="text-brand-yellow" data-id="element-186" />
              <span data-id="element-187">Pagás en pesos argentinos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}